/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 04.07.2016.
 */

const lhEmitMiddleware = function () {

  return function (ref) {

    const dispatch = ref.dispatch;

    return function (next) {

      lh.common.events.on(lh.common.events.EVENT_VLIVE_SHOW_OVERLAY, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_VLIVE_SHOW_OVERLAY, payload: data});
        }, 50);
      });

      lh.common.events.on(lh.common.events.EVENT_COLLECTION_NOTIFICATION_UPDATE, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_COLLECTION_NOTIFICATION_UPDATE, payload: data});
        }, 50);
      });

      lh.common.events.on(lh.common.events.EVENT_COLLECTION_RECORDS_UPDATE, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_COLLECTION_RECORDS_UPDATE, payload: data});
        }, 50);
      });

      lh.common.events.on(lh.common.events.EVENT_COLLECTION_FAVORITES_UPDATE, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_COLLECTION_FAVORITES_UPDATE, payload: data});
        }, 50);
      });

      lh.common.events.on(lh.common.events.EVENT_COLLECTION_PURCHASES_UPDATE, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_COLLECTION_PURCHASES_UPDATE, payload: data});
        }, 50);
      });

      lh.common.events.on(lh.common.events.EVENT_COLLECTION_SUBSCRIPTIONS_UPDATE, (data) => {

        setTimeout(function ()  {
          dispatch({type: 'emit-' + lh.common.events.EVENT_COLLECTION_SUBSCRIPTIONS_UPDATE, payload: data});
        }, 50);
      });

      return next;
    };
  }
};

export default lhEmitMiddleware;


// WEBPACK FOOTER //
// ./src/middlewares/lhEmit/index.js